import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { CategoryIcon, Empty, Spinner } from "@/components/Brand";

export default function Categories() {
  const [cats, setCats] = useState(null);
  const [subs, setSubs] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    Promise.all([api.get("/categories"), api.get("/subjects")])
      .then(([c, s]) => { setCats(c.data); setSubs(s.data); })
      .catch((e) => setErr(errMsg(e)));
  }, []);

  if (err) return <div className="mx-auto max-w-7xl px-4 py-16"><Empty text={err} testid="categories-error" /></div>;
  if (!cats) return <Spinner />;
  return (
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-amber-600">Kategori Ujian</p>
      <h1 className="mt-2 text-3xl font-extrabold text-[#0A192F] sm:text-4xl">Semua kategori & materi</h1>
      <div className="mt-10 grid gap-5 md:grid-cols-2">
        {cats.length === 0 && <Empty text="Belum ada kategori." />}
        {cats.map((c) => (
          <div key={c.id} className="card-premium flex flex-col p-6" data-testid={`category-card-${c.slug}`}>
            <div className="flex items-start gap-4">
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-[#0A192F] text-amber-400"><CategoryIcon name={c.icon} /></div>
              <div>
                <h2 className="font-display text-xl font-bold text-[#0A192F]">{c.name}</h2>
                <p className="text-sm text-slate-500">{c.description}</p>
              </div>
            </div>
            <div className="mt-5 flex flex-wrap gap-2">
              {subs.filter((s) => s.category_id === c.id).map((s) => (
                <span key={s.id} className="rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-xs font-semibold text-slate-700">{s.code ? `${s.code} · ` : ""}{s.name}</span>
              ))}
            </div>
            <Link to={`/tryout?kategori=${c.id}`} className="mt-6 self-start text-sm font-bold text-amber-700 hover:underline" data-testid={`category-see-packages-${c.slug}`}>Lihat {c.package_count} paket tryout →</Link>
          </div>
        ))}
      </div>
    </div>
  );
}
